import { render, staticRenderFns } from "./Lighthouse.vue?vue&type=template&id=10e6a0ce&"
import script from "./Lighthouse.vue?vue&type=script&lang=js&"
export * from "./Lighthouse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports